import { Component, EventEmitter, Output, ViewEncapsulation, computed, contentChild, inject } from '@angular/core';
import { MobileExplainTooltipSheetService } from 'src/services/mobile-explain-tooltip-sheet.service';
import { TooltipHeaderDirective } from './tooltip-header.directive';

@Component({
  selector: 'liberro-tooltip-content',
  standalone: false,
  templateUrl: './liberro-tooltip-content.component.html',
  styleUrl: './liberro-tooltip-content.component.less',
  encapsulation: ViewEncapsulation.None,
})
export class LiberroTooltipContentComponent {
  private explainSheet = inject(MobileExplainTooltipSheetService);
  private readonly header = contentChild(TooltipHeaderDirective);

  // todo - instead of emiting value to parent this should be handled automatically
  @Output() public closeClick = new EventEmitter<Event>();
  public readonly hasHeader = computed(() => !!this.header());

  public onCloseClick(event: Event): void {
    event.stopPropagation();
    this.closeClick.emit(event);
    this.explainSheet.close();
  }
}
